import Phone from '../src/Phone';
export default Phone;
